import { createFileRoute } from '@tanstack/react-router';
import { ProcessChainDetailPage } from '@/pages/processes/process-chains';

export const Route = createFileRoute('/$slug/processes/process-chains/$chainId')({
  component: ProcessChainDetailPage
});
